export default {
      id: "sli-notif-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-notif",
      toString: function () {
        return this.url;
      }
    }